import { createSelector } from '@reduxjs/toolkit';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'data';
import { TemplateId } from 'data/templates/api';
import { ProjectTemplateProjectPhase } from '../types';
import { useActiveTemplateId } from './use-active-project-template';

const getAllProjectPhasesSelector = () =>
  createSelector(
    (state: RootState) => state.templates.project,
    (_, templateId: TemplateId) => templateId,
    (project, templateId): { [key: string]: ProjectTemplateProjectPhase } =>
      project.data[templateId].projectPhases,
  );

export const useGetAllProjectPhases = (): {
  [key: string]: ProjectTemplateProjectPhase;
} => {
  const templateId = useActiveTemplateId();
  const templateObject = useMemo(getAllProjectPhasesSelector, []);

  return useSelector((state: RootState) => templateObject(state, templateId));
};
